<template>
  <div>
    <autoLogout />
    <loader :loader="sending" />

    <div class="wrapper-content">
      <encabezado :elementos="encabezado" v-if="showAction(1)" />
      <v-card v-if="showAction(1)">
        <validation-observer ref="observer" v-slot="{ invalid }">
          <v-form @submit.prevent="doAction">
            <v-card-text>
              <v-container>
                <!-- <v-row>
                  <v-col>
                    <h3 class="font-weight-black mb-5">
                      Información de estudio
                      <span class="error--text">{{ idStudy }}</span>
                    </h3>
                  </v-col>
                </v-row> -->
                <v-row dense v-if="model && model.idPatient">
                  <v-col>
                    <patient-information :model="model" />
                  </v-col>
                </v-row>
                <v-row dense v-if="model && model.idStudy">
                  <v-col>
                    <study-information :model="model" />
                  </v-col>
                </v-row>
                <v-row dense class="ml-2">
                  <v-col md="4" sm="12" cols="12">
                    <strong>Etiqueta: </strong>
                    {{ model.laboratoryLabel }}</v-col
                  >
                  <v-col md="4" sm="12" cols="12">
                    <strong>Fecha de resultados: </strong>
                    {{ model.dateResultText }}
                  </v-col>
                </v-row>

                <v-row class="text-center mb-3">
                  <v-col>
                    <v-btn color="secondary" @click="dialog = true">
                      Información de consulta
                      <v-icon right>mdi-information-variant</v-icon>
                    </v-btn>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col>
                    <validation-provider
                      v-slot="{ errors }"
                      name="Observación"
                      rules="max:300"
                    >
                      <v-textarea
                        rows="3"
                        v-model="model.observation"
                        :counter="300"
                        :maxlength="300"
                        prepend-icon="mdi-file-document-edit-outline"
                        required
                        name="Comentario"
                        :error-messages="errors"
                        outlined
                        dense
                        clearable
                        label="Observación"
                        :disabled="readOnly"
                      />
                    </validation-provider>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col>
                    <h3
                      class="font-weight-black"
                      v-if="$utilFront.nonEmptyList(model.categories)"
                    >
                      Resultados de laboratorio
                    </h3>
                  </v-col>
                </v-row>
                <template v-if="$utilFront.isEmpty(model.idStudyResults)">
                  <v-row>
                    <v-col>
                      <h4 class="font-italic yellow--text">
                        Sin resultados disponibles; espere o ingrese de forma
                        manual.
                      </h4>
                    </v-col>
                  </v-row>
                </template>

                <v-row>
                  <v-col>
                    <div
                      v-for="(category, index) in model.categories"
                      :key="index"
                    >
                      <span class="font-weight-black">
                        {{ category.name }} 
                        <br/>
                        <br/>
                      </span>
                      <v-data-table
                        :headers="headers"
                        :items="category.parameters"
                        :search="search"
                        :items-per-page="-1"
                        :footer-props="{
                          'items-per-page-text': 'Elementos por página',
                          'items-per-page-all-text': 'Todo',
                          'disable-items-per-page': true,
                        }"
                        hide-default-footer
                        no-results-text="Sin resultados coincidentes con el búsqueda"
                        loading-text="Cargando..."
                        no-data-text="Sin resultados disponibles"
                        dense
                      >
                        <template v-slot:[`item.result`]="{ item, index }">
                          <validation-provider
                            v-slot="{ errors }"
                            :name="`${item.name}`"
                            :key="index"
                            rules="required"
                          >
                            <v-text-field
                              dense
                              v-if="
                                item.type == 0 ||
                                item.referenceResults.length === 0
                              "
                              :disabled="
                                sending ||
                                readOnly ||
                                item.name.includes($cnst.CATEGORY_GLOMERULAR)
                              "
                              v-model.trim="item.result.result"
                              :error-messages="errors"
                              class="my-input input"
                              :key="index"
                              autocomplete="off"
                              @input="
                                if (item.result.result)
                                  item.result.result = $event.toUpperCase();
                                if (
                                  item.name.includes($cnst.CATEGORY_CREATININA)
                                )
                                  getValueGlomerular($event);
                              "
                            />
                            <v-autocomplete
                              v-if="
                                item.type == 1 &&
                                item.referenceResults.length > 0
                              "
                              v-model="item.result.result"
                              :disabled="sending || readOnly"
                              :items="item.referenceResults"
                              item-text="value"
                              item-value="value"
                              :error-messages="errors"
                            >
                            </v-autocomplete>
                          </validation-provider>
                        </template>

                        <template v-slot:[`item.parameter`]="{ item }">
                          {{ item.name }}
                        </template>
                        <template v-slot:[`item.unitMeasurement`]="{ item }">
                          <span
                            v-if="$utilFront.nonEmpty(item.unitMeasurement)"
                          >
                            {{ item.unitMeasurement }}</span
                          >
                          <span v-else> - - - </span>
                        </template>
                        <template v-slot:[`item.referenceValue`]="{ item }">
                          <span
                            v-if="$utilFront.nonEmptyList(item.referenceValues)"
                          >
                            <span
                              v-for="(vr, index) in item.referenceValues"
                              :key="`${index}vr`"
                            >
                              {{ vr.value }}<br />
                            </span>
                          </span>
                          <span v-else> - - - </span>
                        </template>
                      </v-data-table>

                      <v-row class="mt-4" align="center">
                        <v-col md="4" offset="2">
                          <v-text-field
                            v-model="category.method"
                            :counter="200"
                            label="Método"
                            disabled
                            required
                            prepend-icon="mdi-pencil-remove-outline"
                            autocomplete="off" dense
                          />
                        </v-col>
                        <v-col md="4">
                          <v-text-field
                            v-model="category.sample"
                            :counter="200"
                            label="Muestra"
                            disabled
                            required
                            prepend-icon="mdi-file-document"
                            autocomplete="off" dense
                          />
                        </v-col>
                      </v-row>
                    </div>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions class="text-center">
              <v-col>
                <v-btn
                  type="button"
                  color="error"
                  plain
                  @click="$router.go(-1)"
                >
                  <v-icon left>mdi-chevron-left</v-icon>
                  Volver
                </v-btn>
              </v-col>
              <v-col v-if="!readOnly">
                <v-btn
                  type="submit"
                  :disabled="
                    invalid ||
                    sending ||
                    $utilFront.isEmptyList(model.categories)
                  "
                  color="primary"
                >
                  Validar estudio <v-icon right>mdi-check-all</v-icon>
                </v-btn>
              </v-col>
            </v-card-actions>
          </v-form>
        </validation-observer>
      </v-card>
    </div>

    <v-dialog v-model="dialog" v-if="dialog" persistent max-width="1200" eager>
      <v-card>
        <v-card-title>
          <h3>Información de consulta</h3>
        </v-card-title>
        <v-card-text>
          <v-row dense>
            <v-col>
              <patient-information :model="info" />
            </v-col>
          </v-row>
          <v-row dense>
            <v-col>
              <study-information :model="info" />
            </v-col>
          </v-row>

          <v-row dense class="mt-4 mb-4">
            <v-col cols="12">
              <h3 class="font-weight-black mb-5">Signos vitales</h3>
            </v-col>
            <v-col cols="4" v-for="(input, index) in vitalSign" :key="index">
              <strong> {{ input.label }} </strong>
              <span> {{ input.value }} {{ input.suffix }} </span>
            </v-col>
          </v-row>
          <v-row v-for="(antecedent, index) in antecedents" :key="index" dense>
            <v-col cols="12">
              <h3 class="font-weight-black mb-5">
                {{ antecedent.description }}:
              </h3>
            </v-col>
            <br />
            <v-col
              v-for="(question, subindex) in antecedent.questions"
              :key="subindex"
            >
              {{ question.answer ? question.answer : "----" }}
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <h3 class="font-weight-black">Diagnóstico</h3>
            </v-col>
          </v-row>

          <v-row>
            <v-col>
              <p v-for="(diagnostic, index) in item.cie10List" :key="index">
                {{ diagnostic }}
              </p>
            </v-col>
          </v-row>

          <v-row>
            <v-col>
              <h3 class="font-weight-black mb-5">Detalles de diagnóstico</h3>
            </v-col>
          </v-row>
          <v-row>
            <v-col
              @click.right.prevent
              @copy.prevent
              @paste.prevent
              ondrop="return false;"
            >
              <v-textarea
                v-model="info.diagnosticDetails"
                outlined
                disabled
                rows="1"
                auto-grow
              >
              </v-textarea>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="text-center">
          <v-col>
            <v-btn color="error" plain @click="dialog = false">
              Volver <v-icon right>mdi-close</v-icon>
            </v-btn>
          </v-col>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import PatientInformation from "@/app/components/common/patient/PatientInformation.vue";
import StudyInformation from "@/app/components/interpretation/PatientInterpretationAppoInfo.vue";
import Encabezado from "@/app/components/base/header/Header.vue";
import Sidebar from "@/components/Sidebar";
import AutoLogout from "@/components/AutoLogout.vue";
import Loader from "@/components/Loader.vue";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { UtilFront } from "@/core/";

import {
  LaboratoryRequest,
  EvaluationRequest,
  VitalSignRequest,
  StudyRequest,
} from "@/core/request";
import moment from "moment";

export default {
  name: "Antecedentes",
  components: {
    Loader,
    Sidebar,
    Encabezado,
    ValidationObserver,
    ValidationProvider,
    AutoLogout,
    PatientInformation,
    StudyInformation,
  },
  data() {
    return {
      sending: false,
      dialog: false,
      readOnly: false,
      index: -1,
      action: 1,
      list: [],
      model: {},
      service: LaboratoryRequest,
      search: "",
      headers: [
        { text: "PARÁMETRO", value: "parameter" },
        { text: "RESULTADO", value: "result" },
        { text: "UNIDAD", value: "unitMeasurement", align: "center" },
        { text: "V. REFERENCIA", value: "referenceValue", align: "center" },
        //  { text: "Remover", value: "actions", align: "center", sortable: false},
      ],
      encabezado: {
        icono: "mdi-pencil-circle-outline",
        texto: "Validar resultados de laboratorio",
      },
      deletes: [],
      //News
      idStudy: null,
      parameters: [{ text: "Parámetro", value: "1" }],
      vitalSign: [],
      item: {},
      pathologicals: [],
      heredoFamiliar: [],
      antecedents: [],
      info: {},
      panelPL: [0],
      panelHF: [0],
      edit: false,
    };
  },
  created() {
    this.idStudy = this.$route.params.idStudy || "CHP-8";
    if (this.$utilFront.isEmpty(this.idStudy)) {
      this.$router.go(-1);
    } else {
      this.get();
    }
    if (this.$route.name == "ResultadosLaboratorio2") {
      this.readOnly = true;
      this.encabezado.texto = "Resultados de laboratorio";
    } else if (this.$route.name == "ResultadosLaboratorio") {
      this.edit = this.$route.params.edit;
    }
    this.getStudy();
    this.getVitalSignByPatient();
    this.getAntecentsByPerson();
  },
  watch: {
    "model.categories": function (val) {},
  },
  methods: {
    catchError: (e, x) => {
      UtilFront.errorhttp(e);
    },
    showAction(action) {
      return this.action == action;
    },
    changeAction(action) {
      if (action == 1) {
        this.$refs.observer.reset();
        this.model = {};
        this.action = action;
      } else {
        this.action = action;
      }
    },
    doAction() {
      switch (this.action) {
        case 1:
          if (this.edit) {
            // console.log("update")
            this.update();
          } else {
            this.save();
          }
          break;
        default:
      }
    },
    get() {
      this.sending = true;
      this.service
        .get({ idStudy: this.idStudy })
        .then((res) => {
          let { data, response, message } = res.data;
          if (response) {
            this.model = data;
            this.model.dateResultText = this.$utilFront.nonEmpty(
              data.dateResultText
            )
              ? data.dateResultText
              : "ND";
          } else {
            message = message || "Ocurrió un error al obtener la información.";
            this.$utilFront.notifications(message, "ERROR");
          }
        })
        .catch(this.catchError)
        .finally(() => {
          this.sending = false;
        });
    },
    update() {
      if (!this.sending) {
        this.sending = true;
        let params = {
          idHumanResource: this.$utilFront.getIdHumanResource(),
          idStudy: this.idStudy,
          idStudyResults: this.model.idStudyResults,
          observation: this.model.observation,
          results: [],
        };

        for (let i = 0; i < this.model.categories.length; i++) {
          const category = this.model.categories[i];
          for (let j = 0; j < category.parameters.length; j++) {
            const parameter = category.parameters[j];
            let result = parameter.result;
            params.results.push({
              idResults: result.idResults,
              result: result.result,
              idParameter: parameter.idParameter,
            });
          }
        }

        this.service
          .update(params)
          .then((res) => {
            let { data, response, message } = res.data;
            if (response) {
              this.$utilFront.notifications(
                "Se ha actualizado correctamente.",
                "SUCCESS"
              );
              this.$router.go(-1);
            } else {
              data - data || "Ocurrió un error durante el registro.";
              this.$utilFront.notifications(data, "ERROR");
            }
          })
          .catch(this.catchError)
          .finally(() => {
            this.sending = false;
          });
      }
      this.edit = false;
    },
    save() {
      if (!this.sending) {
        this.sending = true;
        let params = {
          idHumanResource: this.$utilFront.getIdHumanResource(),
          idStudy: this.idStudy,
          idStudyResults: this.model.idStudyResults,
          observation: this.model.observation,
          results: [],
        };

        for (let i = 0; i < this.model.categories.length; i++) {
          const category = this.model.categories[i];
          for (let j = 0; j < category.parameters.length; j++) {
            const parameter = category.parameters[j];
            let result = parameter.result;
            params.results.push({
              idResults: result.idResults,
              result: result.result,
              idParameter: parameter.idParameter,
            });
          }
        }

        this.service
          .save(params)
          .then((res) => {
            let { data, response, message } = res.data;
            if (response) {
              this.$utilFront.notifications(
                "Se ha registrado correctamente.",
                "SUCCESS"
              );
              this.$router.go(-1);
            } else {
              data - data || "Ocurrió un error durante el registro.";
              this.$utilFront.notifications(data, "ERROR");
            }
          })
          .catch(this.catchError)
          .finally(() => {
            this.sending = false;
          });
      }
    },
    pushResult() {
      if (this.$utilFront.isEmptyList(this.list)) {
        this.list = [];
      }
      this.list.push({
        parameter: "",
        result: "",
        unitMeasurement: "",
        referenceValue: [],
      });
    },
    deleteResult(item, index) {
      if (this.$utilFront.isEmpty(item.idResult)) {
        this.list.splice(index, 1);
      } else {
        this.deletes.push(item.idResult);
      }
    },

    getStudy() {
      let id = this.idStudy;
      let post = {
        idStudy: id,
      };
      StudyRequest.getStudy(post).then((res) => {
        if (res.data.code === 200 && res.data.status === "OK") {
          this.item = res.data.data;
          let address = `${this.item.address.street} #${this.item.address.outdoorNumber},
          ${this.item.address.colonyKey}, ${this.item.address.municipalityKey},
          ${this.item.address.federalEntityKey}, ${this.item.address.postalCode}`;
          address = address
            .replace("null", "")
            .replace("  ", " ")
            .replace("\n", " ")
            .replace("\n ", " ");
          let birthDate =
            moment(new Date(this.item.birthDate))
              .locale("es")
              .format("DD/MM/YYYY") || "---";
          this.content = this.item.textDiagnostic;
          // console.log(this.item);
          this.info = {
            idPatient: this.item.idPatient,
            idStudy: this.item.idStudy,
            fullNamePatient: this.item.fullNamePatient,
            gender: this.item.sexPatient,
            curp: this.item.curpPatient,
            birthDate: birthDate,
            address: address,
            phone: this.item.phoneNumber,
            homePhone: this.item.homePhone,
            email: this.item.email,
            studyModality: this.item.nameStudy,
            modality: this.item.nameModality,
            status: this.item.status,
            accessionNumber: this.item.accessionNumber,
            registrationDate:
              moment(new Date(this.item.registrationDateStudy))
                .locale("es")
                .format("DD/MM/YYYY HH:mm") || "---",
            nacPatient:
              moment(new Date(this.item.birthDate))
                .locale("es")
                .format("DD/MM/YYYY") || "---",
            sexPatient: this.item.sexPatient,
            age: this.calculate_age(new Date(this.item.birthDate)),
            diagnosticDetails: this.item.diagnosticDetails
              ? this.item.diagnosticDetails
              : "----",
            cie10List: this.item.cie10List,
          };
          this.checkStatus();
          //this.validateData();
        } else if (res.data.code === 401) {
          this.unauthorized();
        }
      });
    },

    getVitalSignByPatient() {
      VitalSignRequest.findAllByPatientOrStudyOrMedicalPractice({
        idStudy: this.idStudy,
      }).then((res) => {
        if (res.data.code === 200) {
          this.vitalSign = res.data.data.map((vital) => {
            let type = "";
            if (vital.vitalSignType.type === 1) {
              type = "number";
            } else if (vital.vitalSignType.type === 2) {
              type = "text";
            }
            let required = 0;
            if (vital.vitalSignType.required === 1) {
              required = true;
            } else if (vital.vitalSignType.required === 2) {
              required = false;
            }

            return {
              idVitalSignType: vital.vitalSignType.idVitalSignType,
              type: type,
              label: vital.vitalSignType.name,
              suffix: vital.vitalSignType.suffix,
              status: vital.vitalSignType.status,
              required: required,
              value: vital.description,
              idVitalSigns: vital.idVitalSigns,
            };
          });
        } else if (res.data.code === 401) {
          this.unauthorized();
        }
      });
    },
    getAntecentsByPerson() {
      this.pathologicals = [];
      this.sending = true;

      let params = { idPerson: this.$route.params.idPerson, type: 2 };
      EvaluationRequest.listByPersonAndType(params)
        .then((res) => {
          let { data, response, message } = res.data;
          if (response) {
            this.pathologicals = data;
            // this.panelPL = data.map((it, i) => {
            //   return i;
            // });
            // setTimeout(
            //   function() {
            //     this.panelPL = [0];
            //   }.bind(this),
            //   1000
            // );
          }
        })
        .finally(() => {
          this.getAntecentsByPersonHF();
        });
    },

    getAntecentsByPersonHF() {
      this.heredoFamiliar = [];
      this.sending = true;
      let params = {
        type: 3,
        idPerson: this.$route.params.idPerson,
      };
      EvaluationRequest.listByPersonAndType(params)
        .then((res) => {
          let { data, response, message } = res.data;
          if (response) {
            this.heredoFamiliar = data;
            // this.panelHF = data.map((it, i) => {
            //   return i;
            // });
            // setTimeout(
            //   function() {
            //     this.panelHF = [0];
            //   }.bind(this),
            //   1000
            // );
          }
        })
        .finally(() => {
          this.sending = false;
          this.getAntecedents();
        });
    },
    getAntecedents() {
      if (this.heredoFamiliar && this.pathologicals) {
        this.antecedents = this.heredoFamiliar.concat(this.pathologicals);
      }
    },
    calculate_age(dob) {
      var diff_ms = Date.now() - dob.getTime();
      var age_dt = new Date(diff_ms);

      return Math.abs(age_dt.getUTCFullYear() - 1970);
    },
    checkStatus() {
      if (this.info.status == 1) {
        this.visible = true;
      }
    },

    getValueGlomerular(event) {
      if (event) {
        const ptnAge = parseInt(
          this.model.patientAge.split(" ").slice(0, -1).toString()
        );

        const fWeight = this.vitalSign
          .filter((item) => item.label.includes(this.$cnst.WEIGHT_VITAL_SIGN))
          .map((subitem) => subitem.value);

        const ptnWeight = parseInt(fWeight.toString());

        this.model.categories
          .filter((cat) => cat.name.includes(this.$cnst.CATEGORY_GLOMERULAR))
          .map((item) => item.parameters)
          .map((subitem, index) => {
            if (this.model.patientGender.toUpperCase().includes("FEMENINO")) {
              (
                (subitem[index].result.result =
                  (140 - ptnAge) * (ptnWeight / 72) * event) * 0.85
              ).toFixed(2);
            } else {
              (subitem[index].result.result =
                (140 - ptnAge) * (ptnWeight / 72) * event).toFixed(2);
            }
            return subitem;
          });
      }
    },
  },
};
</script>
<style>
/* .my-input input {
  text-transform: uppercase;
} */
.v-data-table > .v-data-table__wrapper {
  border-bottom: none;
  max-height: 2000px !important;
}
</style>
